// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IVehicleOwnershipReasonType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    isOpOfLaw: boolean;
    sortOrder: number;
    active: boolean;
}

export class VehicleOwnershipReasonType implements IVehicleOwnershipReasonType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public isOpOfLaw: boolean;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Manuf Cert of Origin (MCO) VehicleOwnershipReasonType
	**/
    get ManufCertofOriginMCO(): IVehicleOwnershipReasonType {
        return this.FromId(32);
    }
    /**
		Returns Bill of Sale VehicleOwnershipReasonType
	**/
    get BillofSale(): IVehicleOwnershipReasonType {
        return this.FromId(35);
    }
    /**
		Returns Government Document VehicleOwnershipReasonType
	**/
    get GovernmentDocument(): IVehicleOwnershipReasonType {
        return this.FromId(33);
    }
    /**
		Returns Abandoned Vehicle Authorization VehicleOwnershipReasonType
	**/
    get AbandonedVehicleAuthorization(): IVehicleOwnershipReasonType {
        return this.FromId(1);
    }
    /**
		Returns Repossession VehicleOwnershipReasonType
	**/
    get Repossession(): IVehicleOwnershipReasonType {
        return this.FromId(2);
    }
    /**
		Returns Self-Storage Foreclosure Lien VehicleOwnershipReasonType
	**/
    get SelfStorageForeclosureLien(): IVehicleOwnershipReasonType {
        return this.FromId(3);
    }
    /**
		Returns Transfer on Death Beneficiary VehicleOwnershipReasonType
	**/
    get TransferonDeathBeneficiary(): IVehicleOwnershipReasonType {
        return this.FromId(4);
    }
    /**
		Returns Pending Order of Forfeiture VehicleOwnershipReasonType
	**/
    get PendingOrderofForfeiture(): IVehicleOwnershipReasonType {
        return this.FromId(5);
    }
    /**
		Returns Non-Probate (Estate) VehicleOwnershipReasonType
	**/
    get NonProbateEstate(): IVehicleOwnershipReasonType {
        return this.FromId(6);
    }
    /**
		Returns Divorce Decree VehicleOwnershipReasonType
	**/
    get DivorceDecree(): IVehicleOwnershipReasonType {
        return this.FromId(7);
    }
    /**
		Returns Judgement VehicleOwnershipReasonType
	**/
    get Judgement(): IVehicleOwnershipReasonType {
        return this.FromId(8);
    }
    /**
		Returns Landlords Lien VehicleOwnershipReasonType
	**/
    get LandlordsLien(): IVehicleOwnershipReasonType {
        return this.FromId(9);
    }
    /**
		Returns Mechanics Lien VehicleOwnershipReasonType
	**/
    get MechanicsLien(): IVehicleOwnershipReasonType {
        return this.FromId(10);
    }
    /**
		Returns Probate (Estate) VehicleOwnershipReasonType
	**/
    get ProbateEstate(): IVehicleOwnershipReasonType {
        return this.FromId(11);
    }
    /**
		Returns Sheriffs Sale VehicleOwnershipReasonType
	**/
    get SheriffsSale(): IVehicleOwnershipReasonType {
        return this.FromId(12);
    }
    /**
		Returns Regular VehicleOwnershipReasonType
	**/
    get Regular(): IVehicleOwnershipReasonType {
        return this.FromId(13);
    }
    /**
		Returns Bankruptcy VehicleOwnershipReasonType
	**/
    get Bankruptcy(): IVehicleOwnershipReasonType {
        return this.FromId(20);
    }
    /**
		Returns Conservator/Guardianship/Fiduciary VehicleOwnershipReasonType
	**/
    get ConservatorGuardianshipFiduciary(): IVehicleOwnershipReasonType {
        return this.FromId(21);
    }
    /**
		Returns Conversion VehicleOwnershipReasonType
	**/
    get Conversion(): IVehicleOwnershipReasonType {
        return this.FromId(30);
    }
    /**
		Returns Bond VehicleOwnershipReasonType
	**/
    get Bond(): IVehicleOwnershipReasonType {
        return this.FromId(34);
    }
    /**
		Returns Owner Correction VehicleOwnershipReasonType
	**/
    get OwnerCorrection(): IVehicleOwnershipReasonType {
        return this.FromId(36);
    }
    /**
		Returns Lien Add VehicleOwnershipReasonType
	**/
    get LienAdd(): IVehicleOwnershipReasonType {
        return this.FromId(37);
    }
    /**
		Returns Lien Release VehicleOwnershipReasonType
	**/
    get LienRelease(): IVehicleOwnershipReasonType {
        return this.FromId(38);
    }
    /**
		Returns Lien Correction VehicleOwnershipReasonType
	**/
    get LienCorrection(): IVehicleOwnershipReasonType {
        return this.FromId(39);
    }
    /**
		Returns Entered in Error VehicleOwnershipReasonType
	**/
    get EnteredinError(): IVehicleOwnershipReasonType {
        return this.FromId(40);
    }
    /**
		Returns Recreated Title VehicleOwnershipReasonType
	**/
    get RecreatedTitle(): IVehicleOwnershipReasonType {
        return this.FromId(41);
    }
    /**
		Returns Factory Invoice VehicleOwnershipReasonType
	**/
    get FactoryInvoice(): IVehicleOwnershipReasonType {
        return this.FromId(42);
    }
    /**
		Returns Homemade VehicleOwnershipReasonType
	**/
    get Homemade(): IVehicleOwnershipReasonType {
        return this.FromId(43);
    }

    get DealerSaleTermination(): IVehicleOwnershipReasonType {
        return this.FromId(44);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('32', { id: 32, value: 'ManufCertofOrigin(MCO)', displayValue: 'Manuf Cert of Origin (MCO)', description: 'Manufacturer Certificate of Origin (MCO)', isOpOfLaw: false, sortOrder: 5, active: true });
        this._dictionary.add('35', { id: 35, value: 'BillofSale', displayValue: 'Bill of Sale', description: 'Bill of Sale', isOpOfLaw: false, sortOrder: 10, active: true });
        this._dictionary.add('33', { id: 33, value: 'GovernmentDocument', displayValue: 'Government Document', description: 'Government Document', isOpOfLaw: false, sortOrder: 15, active: true });
        this._dictionary.add('1', { id: 1, value: 'AbandonedVehicleAuthorization', displayValue: 'Abandoned Vehicle Authorization', description: 'Abandoned vehicle authorization for transfer of ownership', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'Repossession', displayValue: 'Repossession', description: 'Vehicle repossessed', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'Self-StorageForeclosureLien', displayValue: 'Self-Storage Foreclosure Lien', description: 'Self-storage facility vehicle foreclosure lien', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'TransferonDeathBeneficiary', displayValue: 'Transfer on Death Beneficiary', description: 'Transfer on Death Beneficiary', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'PendingOrderofForfeiture', displayValue: 'Pending Order of Forfeiture', description: 'Pending Order of Forfeiture/Order of Forfeiture', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'Non-Probate(Estate)', displayValue: 'Non-Probate (Estate)', description: 'Non-Probate (Estate)', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, value: 'DivorceDecree', displayValue: 'Divorce Decree', description: 'Divorce Decree', isOpOfLaw: true, sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, value: 'Judgement', displayValue: 'Judgement', description: 'Judgement', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, value: 'LandlordsLien', displayValue: 'Landlords Lien', description: 'Landlords Lien', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, value: 'MechanicsLien', displayValue: 'Mechanics Lien', description: 'Mechanics Lien', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, value: 'Probate(Estate)', displayValue: 'Probate (Estate)', description: 'Probate (Estate)', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, value: 'SheriffsSale', displayValue: 'Sheriffs Sale', description: 'Sheriffs Sale', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: 'Regular', displayValue: 'Regular', description: 'Default transfer reason, no special circumstance', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('20', { id: 20, value: 'Bankruptcy', displayValue: 'Bankruptcy', description: 'Bankruptcy', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('21', { id: 21, value: 'Conservator/Guardianship/Fiduciary', displayValue: 'Conservator/Guardianship/Fiduciary', description: 'Conservator/Guardianship/Fiduciary', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('30', { id: 30, value: 'Conversion', displayValue: 'Conversion', description: 'Conversion', isOpOfLaw: false, sortOrder: 999999, active: false });
        this._dictionary.add('34', { id: 34, value: 'Bond', displayValue: 'Bond', description: 'Bond', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('36', { id: 36, value: 'OwnerCorrection', displayValue: 'Owner Correction', description: 'Owner Correction', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('37', { id: 37, value: 'LienAdd', displayValue: 'Lien Add', description: 'Lien Add', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('38', { id: 38, value: 'LienRelease', displayValue: 'Lien Release', description: 'Lien Release', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('39', { id: 39, value: 'LienCorrection', displayValue: 'Lien Correction', description: 'Lien Correction', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('40', { id: 40, value: 'EnteredinError', displayValue: 'Entered in Error', description: 'Entered in Error', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('41', { id: 41, value: 'RecreatedTitle', displayValue: 'Recreated Title', description: 'Recreated Title', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('42', { id: 42, value: 'FactoryInvoice', displayValue: 'Factory Invoice', description: 'Factory Invoice', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('43', { id: 43, value: 'Homemade', displayValue: 'Homemade', description: 'Homemade trailer or vehicle', isOpOfLaw: false, sortOrder: 999999, active: true });
        this._dictionary.add('44', { id: 44, value: 'DealerSaleTermination', displayValue: 'Dealer Sale Termination', description: 'Dealer Sale Termination', isOpOfLaw: false, sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IVehicleOwnershipReasonType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IVehicleOwnershipReasonType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IVehicleOwnershipReasonType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IVehicleOwnershipReasonType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IVehicleOwnershipReasonType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
